import Swiper from "swiper";

export default function initHappyPeopleSection() {
   const swiper = new Swiper(".happypeople-reviews-container", {
      slidesPerView: 1,
      spaceBetween: 32,
      centeredSlides: true,
      loop: true,
      breakpoints: {
         768: {
            slidesPerView: 1.5,
         },
      }
   });

   const swiperActionPrev = document.getElementById("happypeople-actions-prev");
   swiperActionPrev?.addEventListener("click", () => swiper.slidePrev());
   const swiperActionNext = document.getElementById("happypeople-actions-next");
   swiperActionNext?.addEventListener("click", () => swiper.slideNext());
}